export default {
  videoPlaylist: '/video-playlist',
  allVideoPlaylist: '/video-playlist/all-playlist',
  videos: '/video',
}
